// extracted by mini-css-extract-plugin
module.exports = {"btn":"FilesClipButton_btn__2jVKg","text":"FilesClipButton_text__iiUYm","empty":"FilesClipButton_empty__2GPFj"};